import { request } from '@/axios';
import type { ModelState, ActivityState } from '@/types/model';
import type { ListResponse } from '@/types/list';
import { useUserStore } from '@/store/user';

interface QueryModelListData {
  ckptType?: string; // SDXL、Pony、Animagine
  key?: string; // 搜索key
  level2Id?: number;
  level3Id?: number;
  pageNo: number;
  pageSize: number;
  loraType?: string; // Lora、Style
  type?: string; // LoRA、Style
  notController?: boolean; // 过滤掉 Lora中的 Controller
  share?: boolean; // 是否共享
}
export function queryModelList(data: QueryModelListData) {
  const userStore = useUserStore();

  return request<ListResponse<ModelState[]>>({
    api: userStore.isLogin ? '/api/model/list' : '/external/externalModelList',
    method: 'post',
    data
  });
}

// 获取活动列表
export function queryActivity() {
  return request<ActivityState[]>({
    api: '/activity/list',
    method: 'post',
    data: {}
  });
}

// 删除共享模型
interface DeleteShareModelRequest {
  id: number;
}

export function deleteShareModel(data: DeleteShareModelRequest) {
  return request<void>({
    api: '/api/model/delShareModel',
    method: 'post',
    data
  });
}

// 编辑共享模型请求参数接口
interface EditShareModelRequest {
  id: number;
  modelName?: string;
}

// 编辑共享模型
export function editShareModel(data: EditShareModelRequest) {
  return request<void>({
    api: '/api/model/editShareModel',
    method: 'post',
    data
  });
}

// 模型共享请求参数接口
interface ShareModelRequest {
  id: number;
}

// 模型共享
export function shareTrainModel(data: ShareModelRequest) {
  return request<void>({
    api: '/api/train/shareModel',
    method: 'post',
    data
  });
}

